module.exports = __webpack_public_path__ + "img/four4Green.ebcae204.jpg";